import { put, takeLatest } from 'redux-saga/effects';
import { DocumentsAPI } from 'api/document/document-core';
import { taskCollection } from 'collections/tasks';
import { getDocTasks } from '../../actions';
import { setTasksLoading } from '../../slice';
function* getDocTasksManager(action) {
    const { payload } = action;
    yield put(setTasksLoading(true));
    try {
        const response = yield DocumentsAPI.getTasks(payload.projectId, payload.documentId);
        taskCollection.push(response);
        yield put(setTasksLoading(false));
    } catch (unused) {
        yield put(setTasksLoading(false));
    }
}
export const watchGetDocTasks = function*() {
    yield takeLatest(getDocTasks.type, getDocTasksManager);
};
